import React, { ReactElement } from 'react';
import { SortSelect } from 'slovlex-idsk-react-components';
import { sortValues } from '../../../constants/NavrhAktEuSortConstants';

const NavrhAktuEuListSort = (): ReactElement => (
  <SortSelect sortList={[
    {
      sort: sortValues[0],
      title: 'Dátum prijatia (od najnovších)',
      sortBy: 'desc',
    },
    {
      sort: sortValues[0],
      title: 'Dátum prijatia (od najstarších)',
      sortBy: 'asc',
    },
    {
      sort: sortValues[1],
      title: 'Identifikátor aktu (A-Z)',
      sortBy: 'asc',
    },
    {
      sort: sortValues[1],
      title: 'Identifikátor aktu (Z-A)',
      sortBy: 'desc',
    },
    {
      sort: sortValues[2],
      title: 'Názov aktu (A-Z)',
      sortBy: 'asc',
    },
    {
      sort: sortValues[2],
      title: 'Názov aktu (Z-A)',
      sortBy: 'desc',
    },
  ]}
  />
);

export default NavrhAktuEuListSort;
